import React from 'react';
import Modal from './Modal';
import Badge from 'models/Badge';
import ActionButton from '../buttons/ActionButton';

type BadgePopupProps = {
  badge?: Badge;
  onClose: () => void;
};

const BadgePopup: React.FC<BadgePopupProps> = ({ badge, onClose }) => {
  return (
    <Modal isOpen={badge !== undefined} onClose={onClose}>
      <div className="badge-popup">
        <h2>🎉 You earned a badge!</h2>
        <>
          <img className="badge" src={badge?.image} alt={badge?.display_name} />
          <h4>{badge?.display_name}</h4>
          <div>
            <p>{badge?.description}</p>
          </div>
        </>
        <ActionButton label="Awesome!" type="go" onClick={onClose} />
      </div>
    </Modal>
  );
};

export default BadgePopup;
